//#region IMPORTS
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { InstoreOrder } from "../../models/instoreOrder";
import { useHistory } from "react-router-dom";
import { Fragment } from "react";
import { Tooltip } from "react-tooltip";
//#endregion

//#region INTERFACE
interface Props {
  instoreOrder: InstoreOrder;
  hide?: boolean
}
//#endregion

export default function InstoreOrdersTableRowActionEdit({
  instoreOrder,
  hide= false
}: Props) {
  //#region SETUP
  // Router
  const history = useHistory();
  //#endregion

  //#region LOGIC
  // Redirect to edit page
  const editHandler = () => {
    history.push(`/instoreorders/edit/${instoreOrder.id}`, true);
  };
  //#endregion

  //#region RENDER
  return (!hide ?
    <Fragment>
      <button
        data-tooltip-content="Edit instore order"
        data-tooltip-variant="warning"
        data-tooltip-place="right"
        data-tooltip-id={String(instoreOrder.id) + "edit"}
        data-tooltip-delay-show={500}
        className="flex items-center gap-4"
      >
        <PencilSquareIcon
          className="w-4 h-4 text-amber-500 hover:text-amber-400"
          onClick={editHandler}
          type="button"
        />
      </button>
      <Tooltip id={String(instoreOrder.id) + "edit"} className="font-bold" />
    </Fragment> : null
  );
  //#endregion
}
